import script from "./ctxSTLViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ctxSTLViewer.vue?vue&type=script&setup=true&lang=js"

import "./ctxSTLViewer.vue?vue&type=style&index=0&id=708b35cd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708b35cd"]])

export default __exports__